export const EMPTY_CHART_MESSAGE = "No data to display, try adjusting the display period.";
